import { MockBase } from '@ali/tbm-app';

export class OnetopMock extends MockBase {
  request(url) {
    return fetch(url).then(res => res.json());
  }
}
